export const LONGTIME = 28800;

export const statusOk = result => ['Ok', 'OK'].includes(result.status);

export const statusManual = result => result.status === 'Manual';
